import { Link, useLocation } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useAuth } from '@/auth/useAuth';
import { isOperatorExperience } from '@/auth/permissions';

/**
 * The NADC.AI assistant button (2026-09-25 seven-destination nav, Michael:
 * "Move NADC.AI to a persistent assistant button at the bottom of the
 * screen"). It left the Office section of the menu for this: one fixed
 * button, bottom right, on every screen, for people who hold nadc_ai.use.
 *
 * It opens the assistant page. Hidden on that page itself (a button to where
 * you already are), on the phone's bottom nav band (it would sit on the More
 * tab), and in the operator experience, whose whole world is My job.
 *
 * It is the bottom of the corner column (CornerStack, 2026-10-28), which
 * places it: bottom right, above a phone's bottom bar, above a panel docked
 * on that bar (the Docuvault upload tray, 2026-10-10) and above any save bar
 * along the bottom of the page — and never under the Guide launcher.
 */
export function AssistantButton() {
  const { user, can } = useAuth();
  const { pathname } = useLocation();
  if (!can('nadc_ai.use') || isOperatorExperience(user)) return null;
  if (pathname === '/nadc-ai' || pathname.startsWith('/nadc-ai/')) return null;

  return (
    <Link
      to="/nadc-ai"
      aria-label="Open NADC.AI assistant"
      title="NADC.AI — ask about projects, scrap, equipment and documents"
      data-testid="assistant-button"
      className="pointer-events-auto flex h-12 items-center gap-2 rounded-full border border-graphite-700 bg-graphite-900 pl-3 pr-4 text-sm font-medium text-graphite-100 shadow-panel transition-colors hover:border-safety-500 hover:text-safety-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-safety-500"
    >
      <span className="flex h-7 w-7 items-center justify-center rounded-full bg-safety-500/15 text-safety-500">
        <Sparkles className="h-4 w-4" aria-hidden />
      </span>
      NADC.AI
    </Link>
  );
}
